module.exports = __WEBPACK_EXTERNAL_MODULE_210__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/Observable"
// module id = 210
// module chunks = 0